class ClientStorage {
  constructor() {
    this.storageKey = 'my.client';
    this.clientInfo = {
      fifth_element: '',
      company_name: '',
      ean: '',
      vat_id: '',
      line_1: '',  //address
      country_alpha2: '',
      city: '',
      name: '',
      email: '',
      phone: '',
      postal_code: '',
      password: '',
      contract_id: '',
      contract_name: '',
      active_contract_section: '',
    };
  }

  getClientInfo() {
    const storage = localStorage || null;

    if (storage && !!storage.getItem(this.storageKey)) {
      const storageObj = JSON.parse(storage.getItem(this.storageKey));
      this.clientInfo = { ...this.clientInfo, ...storageObj };
    }
    return this.clientInfo;
  }

  updateClientInfo(clientUpdatedInfo) {
    const storage = localStorage || null;
    if (storage) {
      const { company_name, ean, vat_id, line_1, country_alpha2, city, name, email, phone, password, postal_code, contract_id, fifth_element, contract_name, active_contract_section } = clientUpdatedInfo;
      const updatedClientObj = {
        ...this.clientInfo,
        ...{ company_name, ean, vat_id, line_1, country_alpha2, city, name, email, phone, password, postal_code, contract_id, fifth_element, contract_name, active_contract_section  },
      };
      let clientInfoString = JSON.stringify(updatedClientObj);
      storage.setItem(this.storageKey, clientInfoString);
    }
  }

  getNames() {
    return {
      companyI18n: 'Firma',
      eanI18n: 'EAN',
      vat_idI18n: 'CVR nr.*',
      line_1I18n: 'Adresse',
      postal_codeI18n: 'Post nr.',
      countryI18n: 'Land',
      cityI18n: 'By',
      nameI18n: 'Navn på kontaktperson',
      emailI18n: 'E-mail',
      phoneI18n: 'Telefon nr.',
      passwordI18n: 'Adgangskode',
    };
  }

  setCountryPhone() {}
}

export default new ClientStorage();
